import { DragService } from './drag.service';

export * from './drag.service';

export const APP_SERVICES = [
  DragService
];
